import React, { useMemo, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import axios from 'axios';

// Configure axios defaults
// The API base URL is now configured in src/services/api.js
// Check for existing auth token and set it in axios headers
const token = localStorage.getItem('authToken');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Color mode context for toggling theme
export const ColorModeContext = React.createContext({ toggleColorMode: () => {}, mode: 'light' });

// Retrieve initial mode from localStorage (defaults to light)
const storedMode = ['light','dim','dark'].includes(localStorage.getItem('themeMode')) ? localStorage.getItem('themeMode') : 'light';

function Main() {
  const [mode, setMode] = useState(storedMode);

  const colorMode = useMemo(() => ({
    mode,
    toggleColorMode: () => {
      setMode((prev) => {
        const order = ['light', 'dim', 'dark'];
        const next = order[(order.indexOf(prev) + 1) % order.length];
        localStorage.setItem('themeMode', next);
        return next;
      });
    }
  }), [mode]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: mode === 'dim' ? 'dark' : mode, // treat dim as dark for contrast
          primary: { main: '#1976d2' },
          secondary: { main: '#dc004e' },
          ...(mode === 'light' && { background: { default: '#f5f5f5' } }),
          ...(mode === 'dark' && { background: { default: '#121212' } }),
          ...(mode === 'dim' && { background: { default: '#30343d', paper: '#383c45' } })
        },
        typography: {
          fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(',')
        }
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HashRouter>
          <App />
        </HashRouter>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
